import { Component, OnInit } from '@angular/core';
import { CognitoService } from '../service/cognito.service';
import { LocalStorageService } from '../local-storage.service';
import { Router } from '@angular/router';
import { ApiService } from '../service/api.service';
import { ManageService } from '../service/manage.service';

@Component({
    selector: 'app-manage-admin',
    templateUrl: './manage-admin.component.html',
    styleUrl: './manage-admin.component.css',
    standalone: false
})
export class ManageAdminComponent implements OnInit{
  isManageUserActive: boolean = false;
  isManageSystemMessageActive: boolean = false;
  isInformationMessageActive: boolean = false;

  constructor(
    private cognitoService: CognitoService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private apiService: ApiService,
    public manageService: ManageService
  ){}

  async ngOnInit() {
    await this.cognitoService.getUser();

    // If the syuser array from DB is empty, it will go implement it
    if(this.cognitoService.syusers.length === 0){
      // Implement the SYUSER array with users from the DB
      this.cognitoService.syusers = await this.apiService.getSYUSERS().then((res)=>{
        return res;
      });
    }
    const jwtData = this.localStorageService.getItem('jwtData');

    // If user is not authenticated, he'll not have a jwt so he'll be redirect automatically to the login portal
    if(jwtData === null){
      this.router.navigate(['/login']);
    }
    const payloadBase64 = jwtData.split('.')[1];
    const decodedPayload = JSON.parse(atob(payloadBase64));

    // If the current user is not an admin user, redirect him to the login page
    if(this.cognitoService.userInfos === null){
      this.router.navigate(['/login']);
    }
    const currentUserDB = this.cognitoService.syusers.find((user: any) => user.userid === decodedPayload.userid);

    // If the current user is not an admin user, redirect him to the login page
    if(currentUserDB && currentUserDB?.syadmin !== 'T'){
      this.router.navigate(['/login']);
    }
    if(currentUserDB && currentUserDB?.userid){
      this.manageService.userId = currentUserDB.userid;
      await this.manageService.getUserRoles(this.manageService.userId, true);
    }
    this.isManageUserActive = true;
  }

  // Function called to reset button on manage-admin component
  setIsActiveFalse(){
    // Set all UI variable at false
    this.isManageUserActive = false;
    this.isManageSystemMessageActive = false;
    this.isInformationMessageActive = false;
  }

  // Function triggered when user click on the user management button
  userManagementClicked(){
    // Reset manage admin buttons
    this.setIsActiveFalse();

    // Acivate manage user buttons
    this.isManageUserActive = true;
  }

  // Function triggered when user click on the system message management button
  systemMessageManagementClicked(){
    // Reset manage admin buttons
    this.setIsActiveFalse();

    // Activate manage system message
    this.isManageSystemMessageActive = true;
  }

  informationManagementClicked(){
    // Reset manage admin buttons
    this.setIsActiveFalse();

    // Activate manage system message
    this.isInformationMessageActive = true;
  }
}
